module.exports = __webpack_public_path__ + "img/amx-9.0fe2348a.jpg";